import { isArrayOf } from "@cartographerio/guard";
import { IO } from "@cartographerio/io";
import { ApiParams, isRoleV1, RoleV1, UserId } from "@cartographerio/types";
import * as fetch from "../../fetch";
import { contentAs } from "../../response";

const basePath = "/permission/v1";

export function get(apiParams: ApiParams, userId: UserId): IO<RoleV1[]> {
  return fetch
    .get({ apiParams, url: { path: `${basePath}/${userId}` } })
    .flatMap(contentAs("RoleV1[]", isArrayOf(isRoleV1)));
}

export function set(
  apiParams: ApiParams,
  userId: UserId,
  roles: RoleV1[]
): IO<RoleV1[]> {
  return fetch
    .put({ apiParams, url: { path: `${basePath}/${userId}` }, body: roles })
    .flatMap(contentAs("RoleV1[]", isArrayOf(isRoleV1)));
}
